
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35029',
  depVersions: {
  "documents-public-ui": "static-1.35029",
  "atom": "static-1.5281",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2702",
  "client-types": "static-1.489",
  "cssUtils": "static-1.852",
  "customer-data-filters-ui": "static-1.40574",
  "customer-data-objects": "static-1.7885",
  "customer-data-property-utils": "static-1.8301",
  "documents-lib": "static-1.35034",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.355",
  "FormsCommonComponents": "static-1.86387",
  "FormUrlGenerator": "static-2.4928",
  "foundations-theming-specialty": "static-1.2364",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5798",
  "hs-test-utils": "static-1.8227",
  "hub-http": "static-1.6422",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11985",
  "HubStyleTokens": "static-2.11678",
  "I18n": "static-7.1650",
  "icons": "static-2.668",
  "jasmine-immutable": "static-1.3226",
  "jasmine-runner": "static-1.6658",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7356",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5600",
  "quartz": "static-1.7301",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16909",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5483",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8381",
  "reference-resolvers-lite": "static-1.8301",
  "reporting-data": "static-1.68366",
  "reporting-reports": "static-1.68044",
  "reporting-snowflake": "static-1.56984",
  "reporting-testing-lib": "static-1.10299",
  "reporting-visualizations": "static-1.60442",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9154",
  "sanitize": "static-1.4682",
  "sanitize-text": "static-1.8351",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1949",
  "signup-constants": "static-1.19378",
  "signup-ui-url-generator": "static-2.8262",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4963",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4959",
  "ui-addon-form-validation": "static-1.11194",
  "ui-asset-management-lib": "static-1.11290",
  "ui-images": "static-2.1212",
  "UIComponents": "static-3.8624",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "viral-links-lib": "static-1.7275",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9862",
  "foundations-components": "static-1.8312",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1079",
  "quartz-core": "static-1.6520",
  "quick-fetch": "static-1.4060",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4863",
  "ui-addon-i18n": "static-1.11351",
  "ui-addon-upgrades": "static-9.18264",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3541",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3578",
  "quartz-webpack": "static-1.3525",
  "foundations-assets": "static-1.5079",
  "foundations-theming": "static-1.4648",
  "hub-http-shared-msw-handlers": "static-1.10449",
  "hubspotter-http": "static-1.4793",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7452",
  "crm-message-bus": "static-1.43549",
  "customer-data-filters-ui-msw-helpers": "static-1.23009",
  "customer-data-objects-ui-components": "static-1.13237",
  "customer-data-reference-ui-components": "static-1.13381",
  "customer-data-ui-utilities": "static-1.10030",
  "events-data-lib": "static-1.443",
  "framework-builder-read-service-client": "static-1.4148",
  "framework-data-schema-quick-fetch": "static-1.7004",
  "framework-data-schema-resolvers": "static-1.7099",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.3987",
  "multi-account-reference-resolvers": "static-1.1186",
  "onboarding-tours": "static-1.16975",
  "reporting-datasets-permissions-lib": "static-1.14257",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2342",
  "trellis-components": "static-1.2361",
  "trellis-theming": "static-1.1156",
  "ui-addon-teams": "static-1.21806",
  "quartz-auth": "static-1.976",
  "ui-business-units-lib": "static-1.9285",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "ai-components-ui-library": "static-1.9466",
  "ContentUtils": "static-1.68951",
  "customer-data-properties": "static-1.52278",
  "forms-ai-lib": "static-1.4626",
  "forms-utils-lib": "static-1.12948",
  "foundations-components-test-utils": "static-1.5795",
  "react-dnd-compat": "static-1.4819",
  "react-tinymce": "static-1.55779",
  "tinymce-config": "static-2.54905",
  "ui-gdpr-components": "static-1.10555",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3633",
  "HeadJS": "static-2.781",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3339",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.223",
  "ui-fonts": "static-1.940",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4528",
  "csstype": "static-1.50",
  "quartz-head": "static-1.966",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1749",
  "external-options-client-types": "static-1.4268",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.976",
  "frontend-preferences-client": "static-1.8131",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3906",
  "reporting-client-types": "static-1.2628",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25967",
  "hubspot-apollo-client": "static-1.5082",
  "foundations-components-legacy": "static-1.1337",
  "quartz-routing": "static-1.731",
  "hs-story-utils": "static-1.9631",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.442",
  "timezone-utils": "static-2.5449",
  "seat-types-lib": "static-1.468",
  "react-create-root-preference": "static-1.50",
  "bend-plugin-foundations-components": "static-1.4581",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.976",
  "quartz-tracking": "static-1.680",
  "bend-plugin-chirp-manifest": "static-1.273",
  "chirp-fetch": "static-1.2092",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6216",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4222",
  "bender-build-tools": "static-1.3323",
  "amplitude-session-replay-browser": "static-1.60",
  "bend-plugin-foundations-theming": "static-1.3131",
  "restore-request-side-panel-lib": "static-1.1413",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.384",
  "pulse": "static-1.821",
  "conditional-properties-service-client": "static-1.3939",
  "crm-pipelines-api-client-types": "static-1.4280",
  "fdsr-migration-layer": "static-1.218",
  "multi-currency-client-types": "static-1.3833",
  "getting-started-shared-tasks": "static-1.19002",
  "growth-data-modal": "static-1.5755",
  "growth-onboarding-confetti": "static-1.3266",
  "growth-onboarding-next-action-utils": "static-1.2500",
  "navigation-components": "static-1.18601",
  "onboarding-tours-client": "static-1.5189",
  "onboarding-tours-utils": "static-1.1041",
  "ui-shepherd-react": "static-3.10466",
  "ui-shepherd-tracker": "static-1.7847",
  "ui-universal-auth": "static-1.9223",
  "user-context": "static-1.5316",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10447",
  "magpie-lib": "static-1.5696",
  "navigation-messaging": "static-1.7928",
  "chatspot-core": "static-1.22344",
  "copilot-toolkit": "static-1.11653",
  "cms-field-types": "static-1.5020",
  "content-icons-ui": "static-1.2288",
  "integrations-lib": "static-1.16791",
  "calling-global-api": "static-1.65194",
  "calling-internal-common": "static-1.31519",
  "calling-lifecycle-internal": "static-1.66576",
  "calling-lifecycle-messages": "static-1.58870",
  "commerce-products-lib": "static-1.10284",
  "crm-links": "static-1.6522",
  "crm-index-visualization-core": "static-1.4404",
  "customer-data-properties-shared-msw-handlers": "static-1.9776",
  "file-manager-components": "static-1.24220",
  "formula-editor": "static-1.14609",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4358",
  "meetings-icalendar-utils-lib": "static-1.836",
  "object-builder-ui-client": "static-1.49403",
  "pipeline-validation-client-types": "static-1.4108",
  "property-value-citations": "static-1.2892",
  "smart-property-lib": "static-1.8097",
  "tiered-pricing": "static-1.1776",
  "topics-actions-lib": "static-1.360",
  "ui-addon-iframeable": "static-1.9280",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20176",
  "tinymce-themes": "static-1.56875",
  "data-token-picker": "static-1.16756",
  "hub-http-contrib": "static-1.3246",
  "interframe": "static-3.4960",
  "tinymce-data": "static-1.40990",
  "tinymce-plugins": "static-1.58019",
  "ui-addon-sales-email": "static-1.5417",
  "onboarding-scopes": "static-1.6662",
  "ui-addon-opt": "static-4.8565",
  "apollo-link-hub-http": "static-2.4858",
  "hubspot-apollo-cache": "static-1.541",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.379",
  "purchase-motions-api": "static-1.6219",
  "event-emitter": "static-1.1155",
  "bend-plugin-pulse": "static-1.324",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2317",
  "growth-onboarding-next-action-components": "static-1.2528",
  "user-context-client": "static-1.4754",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5156",
  "nest": "static-1.441",
  "reactive-lib": "static-1.927",
  "simple-logging-lib": "static-1.3254",
  "unified-auth-core-lib": "static-1.1019",
  "getting-started-shared-tasks-store": "static-1.18120",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1431",
  "integrations-error-boundary-lib": "static-1.14206",
  "integrations-tracking-lib": "static-1.5812",
  "native-integrations-shared-strings": "static-1.7983",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10570",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.737",
  "calling-error-reporting": "static-1.31526",
  "shared-worker-versioning": "static-1.11242",
  "calling-usage-tracker": "static-1.6745",
  "voice-sms-access-library": "static-1.1726",
  "customer-data-tracking": "static-1.7089",
  "commerce-permissions": "static-1.981",
  "products-iframe-lib": "static-1.8409",
  "products-ui-components-shared-msw-handlers": "static-1.10831",
  "location-customization-utils-lib": "static-1.9875",
  "crm-index-associations-lib": "static-1.6646",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10532",
  "sales-views-client-types": "static-1.4462",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4352",
  "video-components-external": "static-1.11926",
  "video-data-lib": "static-1.35584",
  "bark-lib": "static-1.16701",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6092",
  "react-codemirror": "static-1.10845",
  "data-agent-kit": "static-1.510",
  "feedback-loader": "static-1.29666",
  "fsm": "static-1.3937",
  "policy-lib": "static-1.6991",
  "react-colorpicker": "static-2.10414",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10595",
  "FileManagerLib": "static-1.39860",
  "NamespacedHubStyle": "static-2.9192",
  "FileManagerCore": "static-1.39719",
  "content-assistance-lib": "static-1.8063",
  "layout-dnd-components": "static-1.12827",
  "layout-dnd-utils": "static-1.11802",
  "ui-addon-emoji-picker": "static-1.10090",
  "ui-brand-identity-lib": "static-1.16025",
  "InboxConnectUtils": "static-4.15359",
  "meetings-connect-utils-lib": "static-1.7810",
  "breeze-engine-core": "static-1.709",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3216",
  "adobe-sign-auth-lib": "static-1.254",
  "ads-unified-auth-lib": "static-1.774",
  "google-sheets-integration-lib": "static-1.831",
  "microsoft-drive-integration-lib": "static-1.940",
  "surveymonkey-integration-lib": "static-1.276",
  "slack-ui-library": "static-1.10603",
  "calling-orchestration-schema": "static-1.36503",
  "crm-record-cards-service-types": "static-1.3726",
  "content-media-composition-data-lib": "static-1.12966",
  "content-media-compositions": "static-2.16973",
  "media-bridge-lib": "static-1.19274",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16156",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4712",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6214",
  "FileManagerImages": "static-1.37371",
  "video-components": "static-1.13928",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4737",
  "video-embed": "static-1.36418",
  "ui-addon-video-player": "static-1.8911",
  "ui-coaching-tips": "static-1.29120",
  "ContentData": "static-1.69026",
  "layout-data-lib": "static-1.10127",
  "social-insights-client-types": "static-1.22597",
  "outpost": "static-1.4371",
  "growth-onboarding-feedback-components": "static-1.6786",
  "advanced-menus-core": "static-1.15453",
  "advanced-menus-lib": "static-1.12345",
  "ExportDialog": "static-6.10584",
  "ui-memberships-settings-lib": "static-1.34610",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15452",
  "simple-menus-lib": "static-1.16969"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35029",
  "atom": "/atom/static-1.5281",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2702",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.852",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40574",
  "customer-data-objects": "/customer-data-objects/static-1.7885",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8301",
  "documents-lib": "/documents-lib/static-1.35034",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.355",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86387",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4928",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2364",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5798",
  "hs-test-utils": "/hs-test-utils/static-1.8227",
  "hub-http": "/hub-http/static-1.6422",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11985",
  "HubStyleTokens": "/HubStyleTokens/static-2.11678",
  "I18n": "/I18n/static-7.1650",
  "icons": "/icons/static-2.668",
  "jasmine-immutable": "/jasmine-immutable/static-1.3226",
  "jasmine-runner": "/jasmine-runner/static-1.6658",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7356",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5600",
  "quartz": "/quartz/static-1.7301",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16909",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5483",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8381",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8301",
  "reporting-data": "/reporting-data/static-1.68366",
  "reporting-reports": "/reporting-reports/static-1.68044",
  "reporting-snowflake": "/reporting-snowflake/static-1.56984",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10299",
  "reporting-visualizations": "/reporting-visualizations/static-1.60442",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9154",
  "sanitize": "/sanitize/static-1.4682",
  "sanitize-text": "/sanitize-text/static-1.8351",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1949",
  "signup-constants": "/signup-constants/static-1.19378",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8262",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4963",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4959",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11194",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11290",
  "ui-images": "/ui-images/static-2.1212",
  "UIComponents": "/UIComponents/static-3.8624",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "viral-links-lib": "/viral-links-lib/static-1.7275",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9862",
  "foundations-components": "/foundations-components/static-1.8312",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1079",
  "quartz-core": "/quartz-core/static-1.6520",
  "quick-fetch": "/quick-fetch/static-1.4060",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4863",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11351",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18264",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3541",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3578",
  "quartz-webpack": "/quartz-webpack/static-1.3525",
  "foundations-assets": "/foundations-assets/static-1.5079",
  "foundations-theming": "/foundations-theming/static-1.4648",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10449",
  "hubspotter-http": "/hubspotter-http/static-1.4793",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7452",
  "crm-message-bus": "/crm-message-bus/static-1.43549",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23009",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13237",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13381",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10030",
  "events-data-lib": "/events-data-lib/static-1.443",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4148",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7004",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7099",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3987",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1186",
  "onboarding-tours": "/onboarding-tours/static-1.16975",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14257",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2342",
  "trellis-components": "/trellis-components/static-1.2361",
  "trellis-theming": "/trellis-theming/static-1.1156",
  "ui-addon-teams": "/ui-addon-teams/static-1.21806",
  "quartz-auth": "/quartz-auth/static-1.976",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9285",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9466",
  "ContentUtils": "/ContentUtils/static-1.68951",
  "customer-data-properties": "/customer-data-properties/static-1.52278",
  "forms-ai-lib": "/forms-ai-lib/static-1.4626",
  "forms-utils-lib": "/forms-utils-lib/static-1.12948",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5795",
  "react-dnd-compat": "/react-dnd-compat/static-1.4819",
  "react-tinymce": "/react-tinymce/static-1.55779",
  "tinymce-config": "/tinymce-config/static-2.54905",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10555",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3633",
  "HeadJS": "/HeadJS/static-2.781",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3339",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.223",
  "ui-fonts": "/ui-fonts/static-1.940",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4528",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.966",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1749",
  "external-options-client-types": "/external-options-client-types/static-1.4268",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.976",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8131",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3906",
  "reporting-client-types": "/reporting-client-types/static-1.2628",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25967",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5082",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1337",
  "quartz-routing": "/quartz-routing/static-1.731",
  "hs-story-utils": "/hs-story-utils/static-1.9631",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.442",
  "timezone-utils": "/timezone-utils/static-2.5449",
  "seat-types-lib": "/seat-types-lib/static-1.468",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4581",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.976",
  "quartz-tracking": "/quartz-tracking/static-1.680",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.273",
  "chirp-fetch": "/chirp-fetch/static-1.2092",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6216",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4222",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3131",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1413",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.384",
  "pulse": "/pulse/static-1.821",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3939",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4280",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.218",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3833",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19002",
  "growth-data-modal": "/growth-data-modal/static-1.5755",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3266",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2500",
  "navigation-components": "/navigation-components/static-1.18601",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5189",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1041",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10466",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7847",
  "ui-universal-auth": "/ui-universal-auth/static-1.9223",
  "user-context": "/user-context/static-1.5316",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10447",
  "magpie-lib": "/magpie-lib/static-1.5696",
  "navigation-messaging": "/navigation-messaging/static-1.7928",
  "chatspot-core": "/chatspot-core/static-1.22344",
  "copilot-toolkit": "/copilot-toolkit/static-1.11653",
  "cms-field-types": "/cms-field-types/static-1.5020",
  "content-icons-ui": "/content-icons-ui/static-1.2288",
  "integrations-lib": "/integrations-lib/static-1.16791",
  "calling-global-api": "/calling-global-api/static-1.65194",
  "calling-internal-common": "/calling-internal-common/static-1.31519",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66576",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58870",
  "commerce-products-lib": "/commerce-products-lib/static-1.10284",
  "crm-links": "/crm-links/static-1.6522",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4404",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9776",
  "file-manager-components": "/file-manager-components/static-1.24220",
  "formula-editor": "/formula-editor/static-1.14609",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4358",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.836",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49403",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4108",
  "property-value-citations": "/property-value-citations/static-1.2892",
  "smart-property-lib": "/smart-property-lib/static-1.8097",
  "tiered-pricing": "/tiered-pricing/static-1.1776",
  "topics-actions-lib": "/topics-actions-lib/static-1.360",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9280",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20176",
  "tinymce-themes": "/tinymce-themes/static-1.56875",
  "data-token-picker": "/data-token-picker/static-1.16756",
  "hub-http-contrib": "/hub-http-contrib/static-1.3246",
  "interframe": "/interframe/static-3.4960",
  "tinymce-data": "/tinymce-data/static-1.40990",
  "tinymce-plugins": "/tinymce-plugins/static-1.58019",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5417",
  "onboarding-scopes": "/onboarding-scopes/static-1.6662",
  "ui-addon-opt": "/ui-addon-opt/static-4.8565",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4858",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.541",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.379",
  "purchase-motions-api": "/purchase-motions-api/static-1.6219",
  "event-emitter": "/event-emitter/static-1.1155",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.324",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2317",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2528",
  "user-context-client": "/user-context-client/static-1.4754",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5156",
  "nest": "/nest/static-1.441",
  "reactive-lib": "/reactive-lib/static-1.927",
  "simple-logging-lib": "/simple-logging-lib/static-1.3254",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1019",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18120",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1431",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14206",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5812",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7983",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10570",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.737",
  "calling-error-reporting": "/calling-error-reporting/static-1.31526",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11242",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6745",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1726",
  "customer-data-tracking": "/customer-data-tracking/static-1.7089",
  "commerce-permissions": "/commerce-permissions/static-1.981",
  "products-iframe-lib": "/products-iframe-lib/static-1.8409",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10831",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9875",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6646",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10532",
  "sales-views-client-types": "/sales-views-client-types/static-1.4462",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4352",
  "video-components-external": "/video-components-external/static-1.11926",
  "video-data-lib": "/video-data-lib/static-1.35584",
  "bark-lib": "/bark-lib/static-1.16701",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6092",
  "react-codemirror": "/react-codemirror/static-1.10845",
  "data-agent-kit": "/data-agent-kit/static-1.510",
  "feedback-loader": "/feedback-loader/static-1.29666",
  "fsm": "/fsm/static-1.3937",
  "policy-lib": "/policy-lib/static-1.6991",
  "react-colorpicker": "/react-colorpicker/static-2.10414",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10595",
  "FileManagerLib": "/FileManagerLib/static-1.39860",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9192",
  "FileManagerCore": "/FileManagerCore/static-1.39719",
  "content-assistance-lib": "/content-assistance-lib/static-1.8063",
  "layout-dnd-components": "/layout-dnd-components/static-1.12827",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11802",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10090",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16025",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15359",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7810",
  "breeze-engine-core": "/breeze-engine-core/static-1.709",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3216",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.254",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.774",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.831",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.940",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.276",
  "slack-ui-library": "/slack-ui-library/static-1.10603",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36503",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3726",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12966",
  "content-media-compositions": "/content-media-compositions/static-2.16973",
  "media-bridge-lib": "/media-bridge-lib/static-1.19274",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16156",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4712",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6214",
  "FileManagerImages": "/FileManagerImages/static-1.37371",
  "video-components": "/video-components/static-1.13928",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4737",
  "video-embed": "/video-embed/static-1.36418",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8911",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29120",
  "ContentData": "/ContentData/static-1.69026",
  "layout-data-lib": "/layout-data-lib/static-1.10127",
  "social-insights-client-types": "/social-insights-client-types/static-1.22597",
  "outpost": "/outpost/static-1.4371",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6786",
  "advanced-menus-core": "/advanced-menus-core/static-1.15453",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12345",
  "ExportDialog": "/ExportDialog/static-6.10584",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34610",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15452",
  "simple-menus-lib": "/simple-menus-lib/static-1.16969"
}
};
